import _ from "lodash";

import type { IAverage, IAveragePoP, IAveragePopItem } from "../types";

export const initAverageData = (avarageData): IAverage => {
    if (!avarageData || _.isEmpty(avarageData)) {
        return {
            PagesPerVisit: null,
            TotalUnbouncedVisits: null,
            Visits: null,
            VisitsPerVisitor: null,
            VisitDuration: null,
            UniqueUsers: null,
        };
    }
    return avarageData;
};

const DEFAULT_POP_ITEM: IAveragePopItem = {
    Value: null,
    PreviousPeriodValue: null,
    Change: null,
};

export interface IInitializedAverageDataPop {
    PagesPerVisit: IAveragePopItem;
    TotalUnbouncedVisits: IAveragePopItem;
    Visits: IAveragePopItem;
    VisitsPerVisitor: IAveragePopItem;
    VisitDuration: IAveragePopItem;
    BounceRate: IAveragePopItem;
}

export const initAverageDataPop = (averageData: IAveragePoP): IInitializedAverageDataPop => {
    if (!averageData || _.isEmpty(averageData)) {
        return {
            PagesPerVisit: DEFAULT_POP_ITEM,
            TotalUnbouncedVisits: DEFAULT_POP_ITEM,
            Visits: DEFAULT_POP_ITEM,
            VisitsPerVisitor: DEFAULT_POP_ITEM,
            VisitDuration: DEFAULT_POP_ITEM,
            BounceRate: DEFAULT_POP_ITEM,
        };
    }
    return {
        PagesPerVisit: averageData.PagesPerVisit ?? DEFAULT_POP_ITEM,
        TotalUnbouncedVisits: averageData.TotalUnbouncedVisits ?? DEFAULT_POP_ITEM,
        Visits: averageData.Visits ?? DEFAULT_POP_ITEM,
        VisitsPerVisitor: averageData.VisitsPerVisitor ?? DEFAULT_POP_ITEM,
        VisitDuration: averageData.VisitDuration ?? DEFAULT_POP_ITEM,
        BounceRate: averageData.BounceRate ?? DEFAULT_POP_ITEM,
    };
};
